import { Typography, RadioGroup, RadioGroupItem, Label } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

interface TenantVisibilitySectionProps {
  tenant: string;
  currentTenant: string;
  onChange: (tenant: string) => void;
}

export const TenantVisibilitySection: React.FC<TenantVisibilitySectionProps> = ({
  tenant,
  currentTenant,
  onChange,
}) => {
  return (
    <div className="al-h-full">
      <Typography
        variant="body"
        weight="medium"
        className="al-text-amber-700 al-uppercase al-mb-1 al-block"
      >
        Tenant Visibility
      </Typography>
      <div className="al-bg-amber-50 al-border al-border-amber-200 al-p-3 al-rounded-lg al-min-h-[120px]">
        <RadioGroup
          value={tenant}
          onValueChange={(value: string) => onChange(value)}
          className="al-space-y-2"
        >
          <Stack direction="row" align="center" gap="sm">
            <RadioGroupItem value="All" id="tenant-all-testcase" />
            <Label
              htmlFor="tenant-all-testcase"
              className="al-text-sm al-text-gray-700 al-cursor-pointer"
            >
              All Tenants
            </Label>
          </Stack>
          {currentTenant && (
            <Stack direction="row" align="center" gap="sm">
              <RadioGroupItem value={currentTenant} id="tenant-current-testcase" />
              <Label
                htmlFor="tenant-current-testcase"
                className="al-text-sm al-text-gray-700 al-cursor-pointer"
              >
                {currentTenant} Only
              </Label>
            </Stack>
          )}
        </RadioGroup>
      </div>
    </div>
  );
};
